import React, { useEffect } from 'react';
import LoginForm from 'Components/login/LoginForm';
import Grid from 'rsuite/Grid';
import Row from 'rsuite/Row';
import Col from 'rsuite/Col';
import { useDispatch } from 'react-redux';
import 'Components/login/login.css';
import { logoutAction } from 'Components/login/state/loginAction';
import logo from 'Assets/imagen_login.png';

export default function LoginPage() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(logoutAction())
  }, [dispatch])

  return (
  <Grid fluid>
    <Row>
      <Col md={14} sm={24}>
        <div className='logo__login'>
          <img
              height={360}
              src={logo}
              alt="DTE Manager Logo"
          /> 
        </div>
      </Col>
      <Col md={10} sm={24} className="background">
        <div className='login__container'>
          <LoginForm />
        </div>
      </Col>
    </Row>
  </Grid>
  )
}